import { Field, Form, Formik } from 'formik';
import { Modal } from 'react-bootstrap';
import { DateFormatNew } from '../../../constants/date-picker-constant';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import FormikFormDatePicker from '../../../shared-components/FormikFormHandlers/FormikFormDatePicker';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import ModalFooter from '../../../shared-components/modal/modal-footer';

interface IProps extends IAddEditFormProps<any> {
  customerDueDate:any
  // minDate:any

}

const EditActiveTrayDateForm = (props: IProps) => {
  return (
    <>
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validateOnBlur={false}
        onSubmit={async (values) => {
          props.submitHandler(values);
        }}
      >
        {({ setFieldValue }) => {
          return (
            <Form className="user-form">
              {props.isLoading ? (
                <FormLoader loading={props.isLoading} />
              ) : null}
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group formSet">
                      <Label
                        className="label-style  col-form-label"
                        required={true}
                        label="date"
                      />
                      <Field
                        data-testid="date"
                        className="form-control"
                        name="NewDate"
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        dateFormat={DateFormatNew}
                        as={FormikFormDatePicker}
                        maxDate={props.customerDueDate}
                        minDate={new Date()}
                      />
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <ModalFooter
                id={props.id}
                onModalClosed={props.onModalClosed}
                isLoading={props.isLoading}
                saveNextBtn={'save'}
                backCancelBtn="cancel"
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default EditActiveTrayDateForm;
